import Rule from "../Rule";
import OrderActivity from "../../Crud/OrderActivity";

const groupThreeDiagnosisCodes = [
  "B91",
  "E7500",
  "E7501",
  "E7502",
  "E7509",
  "E7510",
  "E7511",
  "E7519",
  "E7523",
  "E7525",
  "E7527",
  "E7528",
  "E7529",
  "E754",
  "F842",
  "G041",
  "G0482",
  "G0489",
  "G10",
  "G110",
  "G1119",
  "G112",
  "G113",
  "G114",
  "G118",
  "G119",
  "G120",
  "G121",
  "G1220",
  "G1221",
  "G1223",
  "G1224",
  "G1225",
  "G1229",
  "G128",
  "G129",
  "G14",
  "G20",
  "G20C",
  "G214",
  "G231",
  "G241",
  "G309",
  "G3180",
  "G3181",
  "G3182",
  "G3183",
  "G3186",
  "G3189",
  "G320",
  "G3281",
  "G3289",
  "G35",
  "G35A",
  "G35B1",
  "G35B2",
  "G35C1",
  "G35C2",
  "G360",
  "G361",
  "G368",
  "G369",
  "G370",
  "G3781",
  "G3789",
  "G379",
  "G600",
  "G610",
  "G6181",
  "G7001",
  "G7112",
  "G7241",
  "G9389",
  "G939",
  "G94",
  "G950",
  "G9511",
  "G9519",
  "G992",
  "M331",
  "M3322",
  "M60",
  "M609",
  "M611",
  "M6289",
  "Q7960",
  ["G1110", "G1111"],
  ["G20A1", "G20B2"],
  ["G371", "G375"],
  ["G710", "G7109"],
  ["G800", "G809"],
  ["G8100", "G8104"],
  ["G8110", "G8114"],
  ["G8190", "G8194"],
  ["G8220", "G8222"],
  ["G8250", "G8254"],
  ["G830", "G839"],
  ["I69051", "I69959"],
  ["Q000", "Q999"],
  ["Q0700", "Q0703"],
];

function isDiagnosisCodeInGroup(code) {
  if (!code) {
    return false;
  }

  for (const entry of groupThreeDiagnosisCodes) {
    if (Array.isArray(entry) && entry.length === 2) {
      if (code >= entry[0] && code <= entry[1]) {
        return true;
      }
    } else if (entry === code) {
      return true;
    }
  }

  return false;
}

export default class RuleGroup3DxRequiredForBillableHcpcsToEnableDSWOButton extends Rule {
  static message =
    "DSWO cannot be generated due to billing violation. A primary group 3 diagnosis code is required if any billable HCPCS code in the K0848 - K0863 range is present.";

  run() {
    const currentChartData =
      this.currentChartData?.orderActivity?.[this.orderActivityId];

    if ([96, 116].includes(currentChartData.orderStatusReasonId)) {
      return this.pass();
    } // Never fail if in Business Support: Followup, Business Support

    if (currentChartData.insuranceTypeId !== 1) {
      return this.pass();
    } // Only applies to Medicare

    const products = OrderActivity.getProducts(
      currentChartData,
      this.currentChartData,
    )
      .map(
        (orderActivityProduct) =>
          this.currentChartData.product?.[orderActivityProduct.id],
      )
      .filter(Boolean)
      .filter(
        (product) =>
          product.billable === true &&
          product.hcpcs?.toUpperCase() >= "K0848" &&
          product.hcpcs?.toUpperCase() <= "K0863",
      );

    if (products.length === 0) {
      return this.pass();
    } // No matching billable HCPCS

    const firstDiagnosisCode =
      this.currentChartData.diagnosisCode?.[
        currentChartData.firstDiagnosisCodeId
      ];

    if (
      !firstDiagnosisCode ||
      !isDiagnosisCodeInGroup(firstDiagnosisCode.code?.toUpperCase())
    ) {
      return this.fail();
    }

    return this.pass();
  }
}
